import { render, staticRenderFns } from "./MoneyDisplay.vue?vue&type=template&id=55a2d952&"
import script from "./MoneyDisplay.vue?vue&type=script&lang=js&"
export * from "./MoneyDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports